export default "__VITE_ASSET__DJeUJQOZ__"